import { connectorTypes } from "./index";
import { matchesSearchText } from "./matchesSearchText";
import { matchesUrlPattern } from "./matchesUrlPattern";
import type { ConnectorType } from "./types";

// `search` states what kind of connector the requester wants; `targetUrl` only
// says where it lives. Search matches rank first so a hostname coincidence
// (e.g. an MCP server hosted on a vendor's domain) can't shadow stated intent.
export function findConnectorTypes(request: {
  targetUrl?: string | null;
  search?: string | null;
}): ConnectorType[] {
  const matches: ConnectorType[] = [];
  const seen = new Set<string>();
  const add = (type: ConnectorType) => {
    if (type.unlisted || seen.has(type.identifier)) return;
    seen.add(type.identifier);
    matches.push(type);
  };

  if (request.search) {
    for (const type of connectorTypes) {
      if (type.identifier === "apiKey") continue;
      if (
        matchesSearchText(
          [
            type.name,
            type.tagLine,
            ...type.variants.flatMap((v) => [v.identifier, v.keywords]),
          ],
          request.search
        )
      ) {
        add(type);
      }
    }
  }

  if (request.targetUrl) {
    for (const type of connectorTypes) {
      const matchesUrl = type.variants.some((variant) => {
        const urlPattern = variant.defaultUrlPattern({});
        return urlPattern && matchesUrlPattern(urlPattern, request.targetUrl!);
      });
      if (matchesUrl) add(type);
    }
  }

  return matches;
}
